export const mobileOSList = ['Android OS', 'iOS']

export const tabletUserAgent = [
  'iPad',
  'vivo',
  'GT-' // Most Galaxy Tabs
]
